import { render, staticRenderFns } from "./CircleText.vue?vue&type=template&id=8cb12322&scoped=true&"
import script from "./CircleText.vue?vue&type=script&lang=ts&"
export * from "./CircleText.vue?vue&type=script&lang=ts&"
import style0 from "./CircleText.vue?vue&type=style&index=0&id=8cb12322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb12322",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VResponsive})
